import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Download, Clock, Star, Users, BookOpen, Trophy } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-12 pb-10 md:pt-32 md:pb-24 overflow-hidden" data-id="element-59">
      {/* Background glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-polo-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-60" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-61">
        <div className="flex flex-col items-center text-center" data-id="element-62">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center" data-id="element-63">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass-card text-polo-gold text-xs md:text-sm font-medium mb-4 md:mb-6" data-id="element-64">
              <Trophy className="w-4 h-4" data-id="element-65" />
              <span data-id="element-66">#1 Sistema elegido en Argentina</span>
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 md:mb-8 leading-tight" data-id="element-67">
              Pack <span className="text-gradient-gold" data-id="element-68">Polo 360</span>
            </h1>
          </motion.div>

          {/* Mockup image - between title and subtitle */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative cursor-pointer group max-w-2xl w-full mb-6 md:mb-8" onClick={scrollToPricing} data-id="element-69">
            <div className="absolute inset-0 bg-polo-gold/20 rounded-2xl blur-3xl group-hover:bg-polo-gold/30 transition-all duration-500" data-id="element-70"></div>
            <img src="https://cdn.magicpatterns.com/uploads/qnw3YhCJjWfRKfDej3ftHG/Gemini_Generated_Image_8ae3yb8ae3yb8ae3-Photoroom.png" alt="Pack Polo 360" className="relative z-10 w-full h-auto drop-shadow-2xl transform group-hover:-translate-y-2 transition-transform duration-500" data-id="element-71" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col items-center" data-id="element-72">
            <p className="text-lg md:text-2xl text-gray-300 mb-6 md:mb-8 font-light leading-relaxed max-w-3xl" data-id="element-73">
              El sistema más completo de clases, actividades y evaluaciones
              resueltas para el docente de polo.
            </p>

            <p className="text-base md:text-lg text-polo-goldLight mb-8 md:mb-10 font-medium" data-id="element-74">
              Todo el año de polo resuelto. Sin planificar nada desde cero.
            </p>

            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-polo-gold hover:bg-polo-goldHover text-polo-navy font-bold text-lg md:text-xl py-4 px-8 md:py-5 md:px-10 rounded-xl shadow-[0_0_30px_rgba(201,168,76,0.3)] transition-all hover:scale-105 active:scale-95 mb-8" data-id="element-75">
              👉 Quiero acceso inmediato
            </button>

            <div className="flex flex-wrap justify-center gap-4 text-xs md:text-sm text-gray-400 mb-8 md:mb-10" data-id="element-76">
              <div className="flex items-center gap-1.5" data-id="element-77">
                <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-78" />
                <span data-id="element-79">Pago 100% seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-80">
                <Download className="w-4 h-4 text-green-400" data-id="element-81" />
                <span data-id="element-82">Descarga inmediata</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-83">
                <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-84" />
                <span data-id="element-85">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-86">
                <Clock className="w-4 h-4 text-green-400" data-id="element-87" />
                <span data-id="element-88">Acceso de por vida</span>
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-6 pt-6 border-t border-white/10" data-id="element-89">
              <div className="flex items-center gap-2" data-id="element-90">
                <Users className="w-5 h-5 text-polo-gold" data-id="element-91" />
                <span className="font-medium" data-id="element-92">+500 docentes ya lo usan</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-93">
                <div className="flex text-polo-gold" data-id="element-94">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-95" />)}
                </div>
                <span className="font-medium" data-id="element-96">4.9/5 valoración promedio</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-97">
                <BookOpen className="w-5 h-5 text-polo-gold" data-id="element-98" />
                <span className="font-medium" data-id="element-99">
                  +5 Tomos de contenido profesional
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}